import axios from "axios";
import { Auth_Domain, Auth_Port, Auth_Proto } from "../../Component/consts";


class SubscriptionServices {
    addsubscriptionplan(data) {
       return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/addsubscriptionplans`,data)
    }

    updatesubscriptionplans(data){
        return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/updatesubscriptionplans`,data)
    }
    GetAllPlans(){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/getallplans`)
    }
    getAllPlansForTenant(data){
        return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/getallplansfortenant`,data)
    }

    updateSubscriptionPlanStatus(id){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/updatesubscriptionplanstatus/${id}`)
    }
    approvesubscriptionplan(id){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/approvesubscriptionplan/${id}`)
    }
    CreateSubscriptionPlan(id,planid){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/createsubscriptionplan/${id}/${planid}`)
    }
}

export default new SubscriptionServices();
